import { requestGet,requestPost } from '@/utils/request';

const api = {
    LIST: '/op/call_list',
	HANGUPLIST: '/op/call_hangup_list',
	ADD: '/op/call_add',
}

export async function callList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function callAdd(queryParams) {
    return requestPost(api.ADD, queryParams);
}

export async function hangupList(queryParams) {
    return requestGet(api.HANGUPLIST, queryParams);
}